import React, { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  TextField,
  Paper,
  Typography,
  Box,
  Grid,
  Link, SvgIcon
} from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import InputAdornment from "@mui/material/InputAdornment";
const ChangeUsername = () => {
  const [currentUsername, setCurrentUsername] = useState('');
  const [newUsername, setNewUsername] = useState('');
  const [error, setError] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const validateUsername = () => {
    if (newUsername.length < 4) {
      setError('Username must be at least 4 characters long');
      return false;
    }
    if (newUsername === currentUsername) {
      setError('New username cannot be the same as the current username');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateUsername()) {
      // Perform username change logic here
    
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        width: "125% !important",
        position: "absolute",
        left: "-25%",
      }}
    >
      {/* BG */}


      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems="center"
        xs={12}
        sx={{
          backgroundImage: "url(/assets/login/Login-BG-2.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <Grid
          container
          direction={"row"}
          p={3}
          justifyContent="space-around"
          alignItems={"center"}
          xs={8.8}
        >
          <Grid item xs={12} sm={5} md={4} lg={5} xl={6} pb={5}>
            <Box display="flex" alignItems="center">
              <img src="assets/common/Logo-White.svg" width={320} />
            </Box>
          </Grid>

          {/* Login Container */}
          <Grid
            item
            xs={12}
            sm={8}
            md={5}
            lg={5}
            xl={6}
            component={Paper}
            elevation={12}
            sx={{
              borderRadius: 3,
              border: "1px solid #E4EBF7",
              padding: "0",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                width:"100%",
                py: 6,
                px: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                color={colors.grey[100]}
                fontWeight="bold"
                sx={{ m: "0 0 15px 0px", fontSize: 24 }}
              >
                Forgot Username
              </Typography>

              <Typography
                width={"90%"}
                variant="h6"
                color={colors.grey[100]}
                sx={{ textAlign:"center", m: "0 0 15px 0px", color:"#888", fontWeight:"500", fontSize: "16px" }}
              >
              Don't worry! We can help you recover your YCMS Username using your email or mobile number.
              </Typography>


    {/* <Container maxWidth="sm"> */}
    <Box sx={{ width:"100%", padding: "0 5%" }}></Box>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>

        <Grid container justifyContent={"center"}>
          <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          defaultValue="email"
        >
          <FormControlLabel value="email" control={<Radio />} label="Verify Email" />
          <FormControlLabel value="phone" control={<Radio />} label="Verify Phone" />
        </RadioGroup>
        </Grid>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            autoFocus
            name="currentUsername"
            label="Enter Branch Code"
            type="text"
            id="currentUsername"
            value={currentUsername}
            onChange={(e) => setCurrentUsername(e.target.value)}
            sx={{ gridColumn: "span 2" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box sx={{ margin: "0 8px" }}>
                    <SvgIcon sx={{ width:"22px", height:"auto" }}>
                    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.81817 11.0909C1.71141 10.566 1.0043 9.45227 1 8.22732V5.9546C1.00295 5.93901 1.00752 5.92378 1.01364 5.90914C1.01916 5.8474 1.03135 5.78644 1.05 5.72733C1.06286 5.66909 1.0827 5.61262 1.10909 5.55915C1.11465 5.53873 1.12227 5.51894 1.13182 5.50006L3.85908 0.954618C4.01967 0.676423 4.31515 0.503627 4.63635 0.500074H17.3636C17.6869 0.495949 17.988 0.66383 18.1545 0.940982L20.8817 5.48642C20.8913 5.5053 20.8989 5.5251 20.9045 5.54551C20.9309 5.59899 20.9507 5.65546 20.9636 5.71369C20.9822 5.77281 20.9944 5.83377 20.9999 5.89551C21.0025 5.91512 21.0025 5.93499 20.9999 5.9546V8.22732C20.9956 9.45227 20.2885 10.566 19.1818 11.0909V17.7727C19.1818 19.279 17.9607 20.5 16.4545 20.5H5.54544C4.03921 20.5 2.81817 19.279 2.81817 17.7727V11.0909ZM4.18177 9.59095C4.93488 9.59095 5.5454 8.98043 5.5454 8.22732V6.86369H2.81814V8.22732C2.81814 8.98043 3.42866 9.59095 4.18177 9.59095ZM9.1817 18.6818V15.0455H12.8181V18.6818H9.1817ZM14.6367 18.6818H16.4549C16.9569 18.6818 17.3639 18.2748 17.3639 17.7727V11.3637C16.6748 11.2676 16.0361 10.9483 15.5458 10.4546C14.9473 11.0654 14.1282 11.4096 13.273 11.4096C12.4179 11.4096 11.5988 11.0654 11.0003 10.4546C10.4019 11.0654 9.58274 11.4096 8.72761 11.4096C7.87249 11.4096 7.05336 11.0654 6.45489 10.4546C5.96454 10.9483 5.32588 11.2676 4.63672 11.3637V17.7727C4.63672 18.2748 5.04373 18.6818 5.54581 18.6818H7.36398V14.1364C7.36398 13.6343 7.77099 13.2273 8.27307 13.2273H13.7276C14.2297 13.2273 14.6367 13.6343 14.6367 14.1364V18.6818ZM7.36328 6.86377H10.0905V8.2274C10.0905 8.98051 9.48003 9.59103 8.72691 9.59103C7.9738 9.59103 7.36328 8.98051 7.36328 8.2274V6.86377ZM14.6355 6.86377H11.9082V8.2274C11.9082 8.98051 12.5187 9.59103 13.2718 9.59103C14.0249 9.59103 14.6355 8.98051 14.6355 8.2274V6.86377ZM19.1823 8.2274C19.1823 8.98051 18.5718 9.59103 17.8187 9.59103C17.0656 9.59103 16.4551 8.98051 16.4551 8.2274V6.86377H19.1823V8.2274ZM16.8499 2.31826H5.1499L3.51355 5.04552H18.4862L16.8499 2.31826Z" fill="#2F3BF5"/>
<path d="M1 8.22732H0.677417L0.677421 8.22845L1 8.22732ZM2.81817 11.0909H3.14076V10.8869L2.95642 10.7995L2.81817 11.0909ZM1 5.9546L0.683035 5.89467L0.677419 5.92437V5.9546H1ZM1.01364 5.90914L1.31125 6.03359L1.33049 5.98758L1.33493 5.9379L1.01364 5.90914ZM1.05 5.72733L1.35764 5.82436L1.36193 5.81078L1.365 5.79687L1.05 5.72733ZM1.10909 5.55915L1.39836 5.70191L1.41214 5.674L1.42032 5.64397L1.10909 5.55915ZM1.13182 5.50006L0.855207 5.33409L0.849218 5.34407L0.843964 5.35446L1.13182 5.50006ZM3.85908 0.954618L4.13573 1.12061L4.13845 1.11589L3.85908 0.954618ZM4.63635 0.500074V0.177474L4.63278 0.177513L4.63635 0.500074ZM17.3636 0.500074V0.822681L17.3677 0.822629L17.3636 0.500074ZM18.1545 0.940982L18.4311 0.775015L18.431 0.774879L18.1545 0.940982ZM20.8817 5.48642L21.1696 5.34081L21.1643 5.33043L21.1584 5.32045L20.8817 5.48642ZM20.9045 5.54551L20.5932 5.63034L20.6014 5.66037L20.6152 5.68828L20.9045 5.54551ZM20.9636 5.71369L20.6486 5.78323L20.6516 5.79713L20.6559 5.81072L20.9636 5.71369ZM20.9999 5.89551L20.6784 5.9243L20.6801 5.93744L20.9999 5.89551ZM20.9999 5.9546L20.6801 5.91267L20.6773 5.93355V5.9546H20.9999ZM20.9999 8.22732L21.3225 8.22845V8.22732H20.9999ZM19.1818 11.0909L19.0435 10.7995L18.8592 10.8869V11.0909H19.1818ZM5.5454 6.86369H5.86798V6.54111H5.5454V6.86369ZM2.81814 6.86369V6.54111H2.49556V6.86369H2.81814ZM9.1817 15.0455V14.7229H8.85912V15.0455H9.1817ZM9.1817 18.6818H8.85912V19.0044H9.1817V18.6818ZM12.8181 15.0455H13.1406V14.7229H12.8181V15.0455ZM12.8181 18.6818V19.0044H13.1406V18.6818H12.8181ZM14.6367 18.6818H14.3141V19.0044H14.6367V18.6818ZM17.3639 11.3637H17.6865V11.0829L17.4085 11.0442L17.3639 11.3637ZM15.5458 10.4546L15.7746 10.2273L15.5442 9.99526L15.3154 10.2288L15.5458 10.4546ZM11.0003 10.4546L11.2307 10.2288L11.0003 9.99366L10.7699 10.2288L11.0003 10.4546ZM6.45489 10.4546L6.68531 10.2288L6.45646 9.99526L6.22602 10.2273L6.45489 10.4546ZM4.63672 11.3637L4.59218 11.0442L4.31414 11.0829V11.3637H4.63672ZM7.36398 18.6818V19.0044H7.68656V18.6818H7.36398ZM10.0905 6.86377H10.4131V6.54119H10.0905V6.86377ZM7.36328 6.86377V6.54119H7.0407V6.86377H7.36328ZM11.9082 6.86377V6.54119H11.5856V6.86377H11.9082ZM14.6355 6.86377H14.958V6.54119H14.6355V6.86377ZM16.4551 6.86377V6.54119H16.1325V6.86377H16.4551ZM19.1823 6.86377H19.5049V6.54119H19.1823V6.86377ZM5.1499 2.31826V1.99568H4.96726L4.87329 2.15229L5.1499 2.31826ZM16.8499 2.31826L17.1265 2.15229L17.0325 1.99568H16.8499V2.31826ZM3.51355 5.04552L3.23694 4.87956L2.94381 5.3681H3.51355V5.04552ZM18.4862 5.04552V5.3681H19.056L18.7628 4.87956L18.4862 5.04552ZM0.677421 8.22845C0.682158 9.57759 1.46096 10.8042 2.67993 11.3824L2.95642 10.7995C1.96187 10.3277 1.32644 9.32694 1.32258 8.22619L0.677421 8.22845ZM0.677419 5.9546V8.22732H1.32258V5.9546H0.677419ZM0.716026 5.7847C0.701222 5.82011 0.690164 5.85696 0.683035 5.89467L1.31697 6.01453C1.31573 6.02106 1.31381 6.02745 1.31125 6.03359L0.716026 5.7847ZM0.742358 5.6303C0.716712 5.71161 0.699941 5.79546 0.69234 5.88039L1.33493 5.9379C1.33838 5.89935 1.346 5.86128 1.35764 5.82436L0.742358 5.6303ZM0.819822 5.41638C0.781937 5.49314 0.753459 5.5742 0.735004 5.65778L1.365 5.79687C1.37225 5.76399 1.38346 5.73211 1.39836 5.70191L0.819822 5.41638ZM0.843964 5.35446C0.824593 5.39276 0.809147 5.43292 0.797861 5.47433L1.42032 5.64397C1.42016 5.64455 1.41994 5.64511 1.41967 5.64565L0.843964 5.35446ZM3.58247 0.788652L0.855207 5.33409L1.40843 5.66602L4.13569 1.12058L3.58247 0.788652ZM4.63278 0.177513C4.19761 0.182327 3.79728 0.416438 3.57971 0.793347L4.13845 1.11589C4.24206 0.936408 4.43269 0.824927 4.63992 0.822635L4.63278 0.177513ZM17.3636 0.177494H4.63635V0.822655H17.3636V0.177494ZM18.431 0.774879C18.2055 0.399382 17.7975 0.17193 17.3595 0.17752L17.3677 0.822629C17.5763 0.819967 17.7705 0.928278 17.878 1.10708L18.431 0.774879ZM21.1584 5.32045L18.4311 0.775016L17.8779 1.10695L20.6051 5.65239L21.1584 5.32045ZM21.2157 5.46068C21.2044 5.41928 21.189 5.37912 21.1696 5.34081L20.5939 5.63202C20.5936 5.63148 20.5934 5.63091 20.5932 5.63034L21.2157 5.46068ZM21.2786 5.64415C21.2601 5.56056 21.2316 5.4795 21.1937 5.40274L20.6152 5.68828C20.6301 5.71848 20.6413 5.75036 20.6486 5.78323L21.2786 5.64415ZM21.3212 5.86674C21.3136 5.78183 21.2969 5.69798 21.2712 5.61667L20.6559 5.81072C20.6676 5.84764 20.6752 5.88571 20.6786 5.92427L21.3212 5.86674ZM21.3198 5.99653C21.326 5.94908 21.326 5.90103 21.3198 5.85358L20.6801 5.93744C20.679 5.92922 20.679 5.92089 20.6801 5.91267L21.3198 5.99653ZM21.3225 8.22732V5.9546H20.6773V8.22732H21.3225ZM19.32 11.3824C20.539 10.8042 21.3178 9.57759 21.3225 8.22845L20.6773 8.22619C20.6735 9.32694 20.0381 10.3277 19.0435 10.7995L19.32 11.3824ZM19.5043 17.7727V11.0909H18.8592V17.7727H19.5043ZM16.4545 20.8226C18.1389 20.8226 19.5043 19.4571 19.5043 17.7727H18.8592C18.8592 19.1008 17.7826 20.1774 16.4545 20.1774V20.8226ZM5.54544 20.8226H16.4545V20.1774H5.54544V20.8226ZM2.49559 17.7727C2.49559 19.4571 3.86106 20.8226 5.54544 20.8226V20.1774C4.21737 20.1774 3.14076 19.1008 3.14076 17.7727H2.49559ZM2.49559 11.0909V17.7727H3.14076V11.0909H2.49559ZM5.22282 8.22732C5.22282 8.80227 4.75673 9.26837 4.18177 9.26837V9.91353C5.11304 9.91353 5.86798 9.15859 5.86798 8.22732H5.22282ZM5.22282 6.86369V8.22732H5.86798V6.86369H5.22282ZM2.81814 7.18627H5.5454V6.54111H2.81814V7.18627ZM3.14072 8.22732V6.86369H2.49556V8.22732H3.14072ZM4.18177 9.26837C3.60681 9.26837 3.14072 8.80227 3.14072 8.22732H2.49556C2.49556 9.15859 3.2505 9.91353 4.18177 9.91353V9.26837ZM8.85912 15.0455V18.6818H9.50428V15.0455H8.85912ZM12.8181 14.7229H9.1817V15.368H12.8181V14.7229ZM13.1406 18.6818V15.0455H12.4955V18.6818H13.1406ZM9.1817 19.0044H12.8181V18.3592H9.1817V19.0044ZM16.4549 18.3593H14.6367V19.0044H16.4549V18.3593ZM17.0414 17.7727C17.0414 18.0967 16.7788 18.3593 16.4549 18.3593V19.0044C17.1351 19.0044 17.6865 18.453 17.6865 17.7727H17.0414ZM17.0414 11.3637V17.7727H17.6865V11.3637H17.0414ZM15.3169 10.6819C15.857 11.2256 16.5604 11.5774 17.3194 11.6832L17.4085 11.0442C16.7892 10.9579 16.2153 10.6709 15.7746 10.2273L15.3169 10.6819ZM13.273 11.7322C14.2149 11.7322 15.117 11.3531 15.7762 10.6803L15.3154 10.2288C14.7776 10.7777 14.0415 11.087 13.273 11.087V11.7322ZM10.7699 10.6803C11.4291 11.3531 12.3312 11.7322 13.273 11.7322V11.087C12.5046 11.087 11.7685 10.7777 11.2307 10.2288L10.7699 10.6803ZM8.72761 11.7322C9.66943 11.7322 10.5716 11.3531 11.2307 10.6803L10.7699 10.2288C10.2321 10.7777 9.49604 11.087 8.72761 11.087V11.7322ZM6.22448 10.6803C6.88362 11.3531 7.78579 11.7322 8.72761 11.7322V11.087C7.95918 11.087 7.2231 10.7777 6.68531 10.2288L6.22448 10.6803ZM4.68126 11.6832C5.44028 11.5774 6.1437 11.2256 6.68376 10.6819L6.22602 10.2273C5.78539 10.6709 5.21147 10.9579 4.59218 11.0442L4.68126 11.6832ZM4.9593 17.7727V11.3637H4.31414V17.7727H4.9593ZM5.54581 18.3593C5.22189 18.3593 4.9593 18.0967 4.9593 17.7727H4.31414C4.31414 18.453 4.86557 19.0044 5.54581 19.0044V18.3593ZM7.36398 18.3593H5.54581V19.0044H7.36398V18.3593ZM7.0414 14.1364V18.6818H7.68656V14.1364H7.0414ZM8.27307 12.9047C7.59284 12.9047 7.0414 13.4562 7.0414 14.1364H7.68656C7.68656 13.8125 7.94915 13.5499 8.27307 13.5499V12.9047ZM13.7276 12.9047H8.27307V13.5499H13.7276V12.9047ZM14.9593 14.1364C14.9593 13.4562 14.4078 12.9047 13.7276 12.9047V13.5499C14.0515 13.5499 14.3141 13.8125 14.3141 14.1364H14.9593ZM14.9593 18.6818V14.1364H14.3141V18.6818H14.9593ZM10.0905 6.54119H7.36328V7.18635H10.0905V6.54119ZM10.4131 8.2274V6.86377H9.76796V8.2274H10.4131ZM8.72691 9.91361C9.65818 9.91361 10.4131 9.15867 10.4131 8.2274H9.76796C9.76796 8.80236 9.30187 9.26845 8.72691 9.26845V9.91361ZM7.0407 8.2274C7.0407 9.15867 7.79564 9.91361 8.72691 9.91361V9.26845C8.15196 9.26845 7.68586 8.80236 7.68586 8.2274H7.0407ZM7.0407 6.86377V8.2274H7.68586V6.86377H7.0407ZM11.9082 7.18635H14.6355V6.54119H11.9082V7.18635ZM12.2308 8.2274V6.86377H11.5856V8.2274H12.2308ZM13.2718 9.26845C12.6969 9.26845 12.2308 8.80236 12.2308 8.2274H11.5856C11.5856 9.15867 12.3406 9.91361 13.2718 9.91361V9.26845ZM14.3129 8.2274C14.3129 8.80236 13.8468 9.26845 13.2718 9.26845V9.91361C14.2031 9.91361 14.958 9.15867 14.958 8.2274H14.3129ZM14.3129 6.86377V8.2274H14.958V6.86377H14.3129ZM17.8187 9.91361C18.75 9.91361 19.5049 9.15867 19.5049 8.2274H18.8598C18.8598 8.80236 18.3937 9.26845 17.8187 9.26845V9.91361ZM16.1325 8.2274C16.1325 9.15867 16.8874 9.91361 17.8187 9.91361V9.26845C17.2438 9.26845 16.7777 8.80236 16.7777 8.2274H16.1325ZM16.1325 6.86377V8.2274H16.7777V6.86377H16.1325ZM19.1823 6.54119H16.4551V7.18635H19.1823V6.54119ZM19.5049 8.2274V6.86377H18.8598V8.2274H19.5049ZM5.1499 2.64084H16.8499V1.99568H5.1499V2.64084ZM3.79016 5.21149L5.42651 2.48423L4.87329 2.15229L3.23694 4.87956L3.79016 5.21149ZM18.4862 4.72294H3.51355V5.3681H18.4862V4.72294ZM16.5732 2.48423L18.2096 5.21149L18.7628 4.87956L17.1265 2.15229L16.5732 2.48423Z" fill="white"/>
<rect x="8.09766" y="14.0488" width="5.80645" height="5.80645" fill="white"/>
<path d="M8.09766 14.0488V19.8553H13.9041V14.0488H8.09766Z" stroke="#FF0084" stroke-width="0.967742" stroke-linejoin="round"/>
</svg>

                    </SvgIcon>
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="newUsername"
            label="Enter Email"
            type="text"
            id="newUsername"
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box sx={{ margin: "0 8px" }}>
                    <SvgIcon>
                    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 18H6C3 18 1 16.5 1 13V6C1 2.5 3 1 6 1H16C19 1 21 2.5 21 6V13C21 16.5 19 18 16 18Z" stroke="#2F3BF5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 6.5L12.87 9C11.84 9.82 10.15 9.82 9.12 9L6 6.5" stroke="#FF0084" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                    </SvgIcon>
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}


<Box sx={{ mt: 2 }}>
                        <CustomButton
                          // btnBG = "#FFF"
                          // btnColor="#000"
                          btnTxt="Recover Username"
                          // onClick = {navigate(CONSTANT.LOGIN)}
                          type="submit"
                        ></CustomButton>
                        <Grid container justifyContent={"center"}>
                          <Grid item mt={2}>
                            <Link
                              href="/"
                              variant="body2"
                              sx={{
                                textDecoration: "none",
                                fontWeight: "500",
                                fontSize: "0.75rem",
                              }}
                            >
                              Go Back
                            </Link>
                          </Grid>
                          </Grid>
                    </Box>


        </Box>
    </Box>
    {/* </Container> */}

    {/* </Box> */}
    {/* Header */}

    <Box sx={{ position: "absolute", bottom: "0", right: "2%" }}>
              <Typography
                variant="h5"
                color={colors.grey[900]}
                fontWeight="400"
                sx={{ m: "0 0 15px 0px", fontSize: 16 }}
              >
                2024 © YTLC. All Rights Reserved.
              </Typography>
            </Box>
          </Grid>
        </Grid>
</Grid>

    {/* BG */}
    </Grid>
  );
};

export default ChangeUsername;
